import { defineMessages } from 'react-intl';

const prefix =
  'app.containers.TranslationSettings.MergeKeys.DeleteMergeKeyDialog';

export const messages = defineMessages({
  deleteError: {
    id: `${prefix}.deleteError`,
    defaultMessage: 'Could not remove merge key',
  },
  deleteSuccess: {
    id: `${prefix}.deleteSuccess`,
    defaultMessage: 'Merge key removed',
  },
  description: {
    id: `${prefix}.description`,
    defaultMessage: 'Are you sure you want to remove {key}?',
  },
  title: {
    id: `${prefix}.title`,
    defaultMessage: 'Remove merge key?',
  },
});
